import { webshopEnvironment } from "@akina/config";

export function pushGtmEvent(event: string, data?: Record<string, unknown>): void {
  if (!webshopEnvironment.gtmId) return;
  globalThis.dataLayer = globalThis.dataLayer ?? [];
  globalThis.dataLayer.push({ event, ...data });
}
